<script lang="ts">
  import { page } from "$app/state";
  import Layout from "@component/Layout.svelte";
  import { SITE_URL, DEFAULT_OG_IMAGE, alternateUrls } from "$lib/seo/site";

  let { data } = $props();

  const FALLBACK_TITLE = "Practical — Webagentur für JamStack, Design & SEO";
  const FALLBACK_DESC = "Practical entwickelt moderne, schnelle und sichere Websites auf JamStack-Basis — Webdesign, Development, SEO und Ecommerce aus einer Hand.";

  // Pull a description from the YAML: explicit metaDescription wins, else the
  // first main component that carries a description (usually the hero).
  let title = $derived(data?.pageTitle || FALLBACK_TITLE);
  let description = $derived(data?.metaDescription || data?.placeholder?.main?.find((c: { description?: string }) => c?.description)?.description || FALLBACK_DESC);

  let isEn = $derived(page.url.pathname.startsWith("/en"));
  let alts = $derived(alternateUrls(page.url.pathname));
  let canonical = $derived(isEn ? alts.en : alts.de);
  let ogImage = $derived(SITE_URL + DEFAULT_OG_IMAGE);
</script>

<svelte:head>
  <title>{title}</title>
  <meta name="description" content={description} />
  <link rel="canonical" href={canonical} />

  <link rel="alternate" hreflang="de" href={alts.de} />
  {#if !data?.deOnly}
    <link rel="alternate" hreflang="en" href={alts.en} />
  {/if}
  <link rel="alternate" hreflang="x-default" href={alts.de} />

  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Practical" />
  <meta property="og:title" content={title} />
  <meta property="og:description" content={description} />
  <meta property="og:url" content={canonical} />
  <meta property="og:image" content={ogImage} />
  <meta property="og:locale" content={isEn ? "en" : "de_AT"} />
  <meta property="og:locale:alternate" content={isEn ? "de_AT" : "en"} />

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content={description} />
  <meta name="twitter:image" content={ogImage} />
</svelte:head>

<Layout route={data} />
